export default "__VITE_ASSET__5109eae5__"